import {
  GoogleMap,
  InfoWindow,
  Marker,
  useLoadScript
} from '@react-google-maps/api';

import { ShowroomCoordinatesType } from '../../../types/showroom';

/* eslint-disable-next-line */
type SzwfMapsProps = {
  coordinates: ShowroomCoordinatesType;
};

export function SzwfMaps(props: SzwfMapsProps) {
  const { coordinates } = props;

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY as string
  });

  if (isLoaded) {
    const options = {
      pixelOffset: new window.google.maps.Size(0, -45)
    };

    const googleMap = coordinates.multipleCoordinates ? (
      <GoogleMap
        center={coordinates.multipleCoordinates[0]}
        mapContainerClassName="w-full h-full"
        zoom={13}
      >
        {coordinates.multipleCoordinates.map((coordinate) => {
          return <Marker key={coordinate.lat} position={coordinate} />;
        })}
      </GoogleMap>
    ) : (
      <GoogleMap
        center={coordinates}
        mapContainerClassName="w-full h-full"
        zoom={18}
      >
        <Marker position={coordinates}>
          <InfoWindow options={options} position={coordinates}>
            <div className="flex flex-col items-center justify-center mx-2">
              <h1 className="text-[18px] font-bold my-1">
                Sub-Zero and Wolf ({coordinates.locationName})
              </h1>
              <p className="mb-2 text-[16px]">{coordinates.locationAddress}</p>
            </div>
          </InfoWindow>
        </Marker>
      </GoogleMap>
    );

    return (
      <div className="mx-auto mt-5" id="map">
        <div className="relative m-auto w-full max-w-defaultMax h-[300px] md:h-[612px]">
          {googleMap}
        </div>
      </div>
    );
  }

  return null;
}

export default SzwfMaps;
